import { FC, useEffect, useState } from "react";
import { IPlaylistByUrl } from "../../../types/playlists";
import Playlist from "../../../components/playlist/Playlist";
import Button from "../../../components/button/Button";
import IconPlay from "../../../assets/icon/IconPlay";
import IconTotalTimeLength from "../../../assets/icon/IconTotalTimeLength";
import IconLikesTotalCount from "../../../assets/icon/IconLikesTotalCount";
import IconAudioTracksTotalCount from "../../../assets/icon/IconAudioTracksTotalCount";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux-hooks";
import {
  setAudioOverTop,
  setIdTrack,
  setPlayRadio,
  setPlayTrack,
  setTrackLink,
} from "../../../store/slices/main";
import {
  selectPlaylists,
  setSettingPlaylistPlaying,
  setSettingPlaylistTrackNumber,
  setSettingStopPlayingPlaylist,
} from "../../../store/slices/playlists";
import { playlistCards } from "../../../api/asyncThuncks/playlistsCards";
import getSpotifyEmbedUrl from "../../../utils/getSpotifyEmbedUrl";
import CoverImage from "../../../components/common/image/CoverImage";
import getSpotifyEmbedHeight from "../../../utils/getSpotifyEmbedHeight";
import getSpotifyTrackCount from "../../../api/spotifyTrackCount";

type IProps = {
  playlist: IPlaylistByUrl;
  publicUrl?: string;
};

const PlaylistByUrl: FC<IProps> = ({ playlist, publicUrl }) => {
  const dispatch = useAppDispatch();
  const { trackNumber, nextTrackAuto, stopPlayingPlaylist } =
    useAppSelector(selectPlaylists);

  const handleClick = () => {
    if (!playlist?.audiotracks[trackNumber]?.audioPath) return;

    dispatch(setSettingStopPlayingPlaylist(false));
    dispatch(setPlayTrack(true));
    dispatch(setPlayRadio(false));

    if (playlist?.audiotracks[trackNumber].audioPath) {
      dispatch(setTrackLink(playlist?.audiotracks[trackNumber].audioPath));
    }
    if (playlist?.audiotracks[trackNumber]) {
      dispatch(
        setIdTrack({
          idTrack: playlist?.audiotracks[trackNumber].id,
          cover: playlist?.audiotracks[trackNumber].imgPath,
          name: playlist?.audiotracks[trackNumber].name,
          artist: playlist?.audiotracks[trackNumber].artist.name,
          isLiked: playlist?.audiotracks[trackNumber].isLiked,
          trackLink: playlist?.audiotracks[trackNumber].audioPath,
        })
      );
    }
    dispatch(setAudioOverTop(true));
  };

  const spotifyUrl = playlist.commnetByAdmin?.trim();
  const spotifyEmbedUrl = getSpotifyEmbedUrl(spotifyUrl);
  const [spotifyTrackCount, setSpotifyTrackCount] = useState<number | undefined>();

  useEffect(() => {
    if (!spotifyEmbedUrl) {
      setSpotifyTrackCount(undefined);
      return;
    }

    const controller = new AbortController();
    setSpotifyTrackCount(undefined);

    getSpotifyTrackCount(spotifyEmbedUrl, controller.signal)
      .then((count) => {
        if (!controller.signal.aborted) {
          setSpotifyTrackCount(count ?? undefined);
        }
      })
      .catch(() => {
        if (!controller.signal.aborted) {
          setSpotifyTrackCount(undefined);
        }
      });

    return () => controller.abort();
  }, [spotifyEmbedUrl]);

  const spotifyEmbedHeight = getSpotifyEmbedHeight(spotifyTrackCount);

  useEffect(() => {
    if (
      !stopPlayingPlaylist &&
      trackNumber > 0 &&
      trackNumber < playlist.audiotracks.length
    ) {
      if (playlist?.audiotracks[trackNumber]) {
        dispatch(setTrackLink(playlist?.audiotracks[trackNumber].audioPath));
        dispatch(
          setIdTrack({
            idTrack: playlist?.audiotracks[trackNumber].id,
            cover: playlist?.audiotracks[trackNumber].imgPath,
            name: playlist?.audiotracks[trackNumber].name,
            artist: playlist?.audiotracks[trackNumber].artist.name,
            isLiked: playlist?.audiotracks[trackNumber].isLiked,
            trackLink: playlist?.audiotracks[trackNumber].audioPath,
          })
        );
      }
      dispatch(setSettingPlaylistPlaying(false));
    }
  }, [nextTrackAuto, stopPlayingPlaylist]);

  console.log(playlist.commnetByAdmin);
  return (
    <>
      <div className="w-full flex flex-col md:flex-row justify-between items-center md:items-start md:h-[15rem]">
        <div className="max-w-[15rem] min-w-[15rem] h-auto flex justify-start items-center overflow-hidden rounded-lg md:max-w-[15rem] md:min-w-[15rem] md:h-auto cursor-pointer">
          <CoverImage
            className="w-full h-full object-cover"
            src={playlist?.imgPath}
            alt={playlist.title}
          />
        </div>
        <div className="w-full h-full flex flex-col items-center justify-center pt-7 text-center md:items-start md:pl-7 md:pt-0">
          <span className="text-[13px] text-[#707070]">Список відтворення</span>
          <h3 className="pt-2 text-2xl text-black font-bold text-ellipsis overflow-hidden line-clamp-2 text-left">
            {playlist?.title}
          </h3>
          <p className="pt-2 pb-4 text-sm">{playlist?.description}</p>
          <div
            className={`w-full flex items-center justify-center ${
              !spotifyUrl && "pb-7"
            } text-[13px] text-[#707070] md:justify-start`}
          >
            {/* <div className="flex items-center pr-[15px]">
              <div className="pr-1">
                <IconLikesTotalCount />
              </div>
              {playlist?.likesTotalCount}
            </div> */}
            <div className="flex items-center pr-[15px]">
              <div className="pr-1">
                <IconAudioTracksTotalCount />
              </div>
              {playlist?.audioTracksTotalCount}
            </div>
            <div className="flex items-center">
              <div className="pr-1">
                <IconTotalTimeLength />
              </div>
              {playlist?.totalTimeLength}
            </div>
          </div>
          {!spotifyUrl && (
            <Button
              title={"Відтворити плейліст"}
              disabled={!playlist.audiotracks.length}
              className="max-w-min flex items-center justify-end pr-3 py-[6px] flex-row-reverse whitespace-nowrap text-white bg-orange transition-opacity hover:opacity-90 hover:transition-opacity"
              onClick={handleClick}
            >
              <div className="pl-3 pr-[4px]">
                <IconPlay />
              </div>
            </Button>
          )}
        </div>
      </div>
      <div className="w-full border-b border-light_gray pb-[2rem]"></div>
      <div className="w-full">
        {spotifyUrl ? (
          spotifyEmbedUrl ? (
            <iframe
              src={spotifyEmbedUrl}
              title="Spotify"
              width="100%"
              height={spotifyEmbedHeight}
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
          ) : (
            <p role="status">Некоректне посилання на плейліст або альбом Spotify.</p>
          )
        ) : (
          playlist?.audiotracks && (
            <Playlist audioTracks={playlist.audiotracks} />
          )
        )}
      </div>
    </>
  );
};

export default PlaylistByUrl;
